(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-native"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.announcementBar = document.querySelector('.announcement-bar-section');
      this.pluginAnnouncementBar = document.querySelector('#torko-embed-bar, .torko-announce');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();
      this.setMobileAnnouncementHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.announcementBar && 'ResizeObserver' in window) {
        this.announcementBarResizeObserver = new ResizeObserver(() => this.setMobileAnnouncementHeight());
        this.announcementBarResizeObserver.observe(this.announcementBar);
      }

      if (this.pluginAnnouncementBar && 'ResizeObserver' in window) {
        this.pluginAnnouncementBarResizeObserver = new ResizeObserver(() => this.setMobileAnnouncementHeight());
        this.pluginAnnouncementBarResizeObserver.observe(this.pluginAnnouncementBar);
      }
      this.observePluginAnnouncementBar(this.pluginAnnouncementBar);

      if ('MutationObserver' in window) {
        this.pluginAnnouncementObserver = new MutationObserver(() => {
          const pluginAnnouncementBar = document.querySelector('#torko-embed-bar, .torko-announce');
          if (!pluginAnnouncementBar || pluginAnnouncementBar === this.pluginAnnouncementBar) return;

          this.pluginAnnouncementBar = pluginAnnouncementBar;
          this.applyPluginAnnouncementBarPosition(pluginAnnouncementBar);
          this.observePluginAnnouncementBar(pluginAnnouncementBar);
          this.setMobileAnnouncementHeight();

          if ('ResizeObserver' in window) {
            this.pluginAnnouncementBarResizeObserver?.disconnect();
            this.pluginAnnouncementBarResizeObserver = new ResizeObserver(() => this.setMobileAnnouncementHeight());
            this.pluginAnnouncementBarResizeObserver.observe(pluginAnnouncementBar);
          }
        });
        this.pluginAnnouncementObserver.observe(document.documentElement, { childList: true, subtree: true });
      }

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

  setMobileAnnouncementHeight() {
      const pluginAnnouncementBar = this.pluginAnnouncementBar || document.querySelector('#torko-embed-bar, .torko-announce');
      if (pluginAnnouncementBar) {
        this.pluginAnnouncementBar = pluginAnnouncementBar;
        this.applyPluginAnnouncementBarPosition(pluginAnnouncementBar);
      }

      const hasPluginAnnouncementBar = Boolean(pluginAnnouncementBar && pluginAnnouncementBar.offsetHeight);
      document.documentElement.classList.toggle('lumiyear-plugin-announcement-active', hasPluginAnnouncementBar);

      const announcementHeight = hasPluginAnnouncementBar
        ? pluginAnnouncementBar.offsetHeight
        : this.announcementBar?.offsetHeight || 0;
      document.documentElement.style.setProperty('--lumiyear-mobile-announcement-height', `${announcementHeight}px`);
    }

    applyPluginAnnouncementBarPosition(pluginAnnouncementBar) {
      if (!pluginAnnouncementBar) return;

      pluginAnnouncementBar.style.setProperty('left', '0', 'important');
      pluginAnnouncementBar.style.setProperty('position', 'fixed', 'important');
      pluginAnnouncementBar.style.setProperty('right', '0', 'important');
      pluginAnnouncementBar.style.setProperty('top', '0', 'important');
      pluginAnnouncementBar.style.setProperty('width', '100%', 'important');
      pluginAnnouncementBar.style.setProperty('z-index', '10010', 'important');
    }

    observePluginAnnouncementBar(pluginAnnouncementBar) {
      if (!pluginAnnouncementBar || !('MutationObserver' in window)) return;

      this.pluginAnnouncementStyleObserver?.disconnect();
      this.pluginAnnouncementStyleObserver = new MutationObserver(() => {
        this.applyPluginAnnouncementBarPosition(pluginAnnouncementBar);
        this.setMobileAnnouncementHeight();
      });
      this.pluginAnnouncementStyleObserver.observe(pluginAnnouncementBar, { attributes: true, attributeFilter: ['class', 'style'] });
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      this.announcementBarResizeObserver?.disconnect();
      this.pluginAnnouncementBarResizeObserver?.disconnect();
      this.pluginAnnouncementObserver?.disconnect();
      this.pluginAnnouncementStyleObserver?.disconnect();
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.reveal.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.setHeaderHeight();
      this.header.classList.add('shopify-section-header-sticky');
      this.header.classList.add('shopify-section-header-hidden');
      document.documentElement.classList.add('lumiyear-header-hidden');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.setHeaderHeight();
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.documentElement.classList.remove('lumiyear-header-hidden');
    }

    reset() {
      this.setHeaderHeight();
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      document.documentElement.classList.remove('lumiyear-header-hidden');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  function bindDesktopHeaderHoverMenus() {
    const desktopMenuQuery = window.matchMedia('(min-width: 990px)');

    document.querySelectorAll('header-menu').forEach((menu) => {
      if (menu.dataset.hoverBound === 'true') return;

      const details = menu.querySelector('details');
      const summary = menu.querySelector('summary');
      if (!details || !summary) return;

      menu.dataset.hoverBound = 'true';

      summary.addEventListener('click', (event) => {
        const linkUrl = summary.dataset.menuLinkUrl;
        if (!desktopMenuQuery.matches || !linkUrl) return;

        event.preventDefault();
        window.location.href = linkUrl;
      });

      const openMenu = () => {
        if (!desktopMenuQuery.matches) return;

        document.querySelectorAll('header-menu details[open]').forEach((openDetails) => {
          if (openDetails === details) return;

          openDetails.removeAttribute('open');
          openDetails.querySelector('summary')?.setAttribute('aria-expanded', 'false');
        });

        details.setAttribute('open', '');
        summary.setAttribute('aria-expanded', 'true');
      };

      const closeMenu = (event) => {
        if (!desktopMenuQuery.matches) return;
        if (event.relatedTarget && menu.contains(event.relatedTarget)) return;

        details.removeAttribute('open');
        summary.setAttribute('aria-expanded', 'false');
      };

      menu.addEventListener('mouseenter', openMenu);
      menu.addEventListener('mouseover', openMenu);
      menu.addEventListener('pointerenter', openMenu);
      menu.addEventListener('mouseleave', closeMenu);
      menu.addEventListener('mouseout', closeMenu);
      menu.addEventListener('pointerleave', closeMenu);
    });
  }

  bindDesktopHeaderHoverMenus();
  document.addEventListener('shopify:section:load', bindDesktopHeaderHoverMenus);

  function bindHeaderLogoHomeLink() {
    document.querySelectorAll('.header__heading-link').forEach((logoLink) => {
      if (logoLink.dataset.homeLinkBound === 'true') return;

      logoLink.dataset.homeLinkBound = 'true';
      logoLink.addEventListener('click', (event) => {
        event.preventDefault();
        window.location.href = logoLink.getAttribute('href') || '/';
      });
    });
  }

  bindHeaderLogoHomeLink();
  document.addEventListener('shopify:section:load', bindHeaderLogoHomeLink);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        requestAnimationFrame(this.reveal.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.reveal.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-sticky');
      this.header.classList.remove('shopify-section-header-hidden');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  function bindDesktopHeaderHoverMenus() {
    const desktopMenuQuery = window.matchMedia('(min-width: 990px)');

    document.querySelectorAll('header-menu').forEach((menu) => {
      if (menu.dataset.hoverBound === 'true') return;

      const details = menu.querySelector('details');
      const summary = menu.querySelector('summary');
      if (!details || !summary) return;

      menu.dataset.hoverBound = 'true';

      summary.addEventListener('click', (event) => {
        const linkUrl = summary.dataset.menuLinkUrl;
        if (!desktopMenuQuery.matches || !linkUrl) return;

        event.preventDefault();
        window.location.href = linkUrl;
      });

      const openMenu = () => {
        if (!desktopMenuQuery.matches) return;

        document.querySelectorAll('header-menu details[open]').forEach((openDetails) => {
          if (openDetails === details) return;

          openDetails.removeAttribute('open');
          openDetails.querySelector('summary')?.setAttribute('aria-expanded', 'false');
        });

        details.setAttribute('open', '');
        summary.setAttribute('aria-expanded', 'true');
      };

      const closeMenu = (event) => {
        if (!desktopMenuQuery.matches) return;
        if (event.relatedTarget && menu.contains(event.relatedTarget)) return;

        details.removeAttribute('open');
        summary.setAttribute('aria-expanded', 'false');
      };

      menu.addEventListener('mouseenter', openMenu);
      menu.addEventListener('mouseover', openMenu);
      menu.addEventListener('pointerenter', openMenu);
      menu.addEventListener('mouseleave', closeMenu);
      menu.addEventListener('mouseout', closeMenu);
      menu.addEventListener('pointerleave', closeMenu);
    });
  }

  bindDesktopHeaderHoverMenus();
  document.addEventListener('shopify:section:load', bindDesktopHeaderHoverMenus);

  function bindHeaderLogoHomeLink() {
    document.querySelectorAll('.header__heading-link').forEach((logoLink) => {
      if (logoLink.dataset.homeLinkBound === 'true') return;

      logoLink.dataset.homeLinkBound = 'true';
      logoLink.addEventListener('click', (event) => {
        event.preventDefault();
        window.location.href = logoLink.getAttribute('href') || '/';
      });
    });
  }

  bindHeaderLogoHomeLink();
  document.addEventListener('shopify:section:load', bindHeaderLogoHomeLink);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lumiyear-inner-preview"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lumiyear-inner-preview')) {
    customElements.define(
      'lumiyear-inner-preview',
      class LumiyearInnerPreview extends HTMLElement {
        connectedCallback() {
          this.pages = Array.from(this.querySelectorAll('[data-inner-preview-page]'));
          this.dots = Array.from(this.querySelectorAll('[data-inner-preview-dot]'));
          this.current = this.querySelector('[data-inner-preview-current]');
          this.previousButton = this.querySelector('[data-inner-preview-prev]');
          this.nextButton = this.querySelector('[data-inner-preview-next]');
          this.viewer = this.querySelector('.lumiyear-inner-preview__viewer');
          this.dialog = this.querySelector('[data-inner-preview-dialog]');
          this.dialogImage = this.querySelector('[data-inner-preview-dialog-image]');
          this.dialogMedia = this.querySelector('[data-inner-preview-dialog-media]');
          this.closeButton = this.querySelector('[data-inner-preview-close]');
          this.zoomInButton = this.querySelector('[data-inner-preview-zoom-in]');
          this.zoomOutButton = this.querySelector('[data-inner-preview-zoom-out]');
          this.zoomResetButton = this.querySelector('[data-inner-preview-zoom-reset]');
          this.zoomValue = this.querySelector('[data-inner-preview-zoom-value]');
          this.index = 0;
          this.touchStartX = 0;
          this.zoom = 1;

          this.previousButton?.addEventListener('click', () => this.show(this.index - 1, 'previous'));
          this.nextButton?.addEventListener('click', () => this.show(this.index + 1, 'next'));

          this.dots.forEach((dot) => {
            dot.addEventListener('click', () => {
              const nextIndex = Number(dot.dataset.index || 0);
              this.show(nextIndex, nextIndex < this.index ? 'previous' : 'next');
            });
          });

          this.pages.forEach((page) => {
            page.addEventListener('click', () => this.openDialog(page));
          });

          this.viewer?.addEventListener('keydown', (event) => {
            if (event.key === 'ArrowLeft') {
              event.preventDefault();
              this.show(this.index - 1, 'previous');
            }

            if (event.key === 'ArrowRight') {
              event.preventDefault();
              this.show(this.index + 1, 'next');
            }
          });

          this.viewer?.addEventListener(
            'touchstart',
            (event) => {
              this.touchStartX = event.changedTouches[0]?.clientX || 0;
            },
            { passive: true }
          );

          this.viewer?.addEventListener(
            'touchend',
            (event) => {
              const touchEndX = event.changedTouches[0]?.clientX || 0;
              const delta = touchEndX - this.touchStartX;

              if (Math.abs(delta) < 42) return;

              if (delta > 0) this.show(this.index - 1, 'previous');
              else this.show(this.index + 1, 'next');
            },
            { passive: true }
          );

          this.closeButton?.addEventListener('click', () => this.dialog?.close());
          this.zoomInButton?.addEventListener('click', () => this.setZoom(this.zoom + 0.25));
          this.zoomOutButton?.addEventListener('click', () => this.setZoom(this.zoom - 0.25));
          this.zoomResetButton?.addEventListener('click', () => this.setZoom(1));

          this.dialog?.addEventListener('click', (event) => {
            if (event.target === this.dialog) this.dialog.close();
          });

          this.dialog?.addEventListener('close', () => {
            this.setZoom(1);
            if (this.dialogImage) this.dialogImage.style.removeProperty('--inner-preview-zoom');
          });

          this.dialogMedia?.addEventListener(
            'wheel',
            (event) => {
              if (!this.dialog?.open) return;

              event.preventDefault();
              this.setZoom(this.zoom + (event.deltaY < 0 ? 0.2 : -0.2));
            },
            { passive: false }
          );

          this.dialog?.addEventListener('keydown', (event) => {
            if (!this.dialog?.open) return;

            if (event.key === '+' || event.key === '=') {
              event.preventDefault();
              this.setZoom(this.zoom + 0.25);
            }

            if (event.key === '-' || event.key === '_') {
              event.preventDefault();
              this.setZoom(this.zoom - 0.25);
            }

            if (event.key === '0') {
              event.preventDefault();
              this.setZoom(1);
            }
          });

          this.show(0);
        }

        show(nextIndex, direction = 'next') {
          if (!this.pages.length) return;

          const boundedIndex = Math.max(0, Math.min(nextIndex, this.pages.length - 1));

          this.index = boundedIndex;
          this.dataset.direction = direction;

          this.pages.forEach((page, index) => {
            const active = index === boundedIndex;
            page.classList.toggle('is-active', active);
            page.setAttribute('aria-hidden', active ? 'false' : 'true');
            page.tabIndex = active ? 0 : -1;
          });

          this.dots.forEach((dot, index) => {
            const active = index === boundedIndex;
            dot.classList.toggle('is-active', active);
            dot.setAttribute('aria-selected', active ? 'true' : 'false');
          });

          if (this.current) this.current.textContent = String(boundedIndex + 1);
          if (this.previousButton) this.previousButton.disabled = boundedIndex === 0;
          if (this.nextButton) this.nextButton.disabled = boundedIndex === this.pages.length - 1;
        }

        openDialog(page) {
          const image = page.querySelector('img');
          if (!image || !this.dialog || !this.dialogImage) return;

          this.dialogImage.src = image.currentSrc || image.src;
          this.dialogImage.alt = image.alt || '';
          this.setZoom(1);
          if (this.dialogMedia) {
            this.dialogMedia.scrollTop = 0;
            this.dialogMedia.scrollLeft = 0;
          }

          if (typeof this.dialog.showModal === 'function') {
            this.dialog.showModal();
          }
        }

        setZoom(nextZoom) {
          const boundedZoom = Math.max(1, Math.min(nextZoom, 3));
          this.zoom = Math.round(boundedZoom * 100) / 100;

          if (this.dialogImage) {
            this.dialogImage.style.setProperty('--inner-preview-zoom', String(this.zoom));
          }

          if (this.zoomValue) {
            this.zoomValue.textContent = `${Math.round(this.zoom * 100)}%`;
          }

          if (this.zoomOutButton) this.zoomOutButton.disabled = this.zoom <= 1;
          if (this.zoomInButton) this.zoomInButton.disabled = this.zoom >= 3;
          if (this.zoomResetButton) this.zoomResetButton.disabled = this.zoom === 1;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
